module.exports = __webpack_public_path__ + "img/media-library-bg.e58150d2.jpg";